module.exports = __webpack_public_path__ + "img/logo_newway.e24e3cb2.svg";